// extracted by mini-css-extract-plugin
module.exports = {"simpleScrollbars":"_22x7cqjyslW9HRLmrlp-E5","simpleScrollbarsOverflowX":"_3NCOP_D3pMX42FvdFUmmy-","simpleScrollbarsOverflowY":"_2ab8PEi1u7e_G4IJnEnGPa"};